/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-12-28 15:43:29
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsyTextEditor from '../BsyTextEditor';
import BsyTextTag from '../BsyTextTag';
import { BsyWidget } from '../BsyWidget';
import './index.css'
import tipAlert from '../../Login/BsyAlertTip/Staticize';

class BsyShareUrlPane extends BsyWidget {


    constructor(props) {
        super({
            baseCls: "bsy-share-url",
            url: "",
            hasCopy: !0,
            hasOpen: !0,
            hasQrcode: !0,
            hasSeting: !1,
            onSetingClick: null,
            ...props
        })
    }

    render() {

        const { cssName, url } = this.options;
        var n = 0;
        if (this.options.hasCopy) n++;
        if (this.options.hasOpen) n++;
        if (this.options.hasQrcode) n++;
        return (
            <div className={cssName + ' xxx-' + n}

                ref={this.element}
            >
                <BsyTextEditor
                    value={url}
                    width={'100%'}
                ></BsyTextEditor>
                <div className="btn-wrapper">
                    {
                        this.options.hasCopy ? <div className="btn copy" onClick={e => {
                            BsyUtils.copyToClipboard(url, function () {
                                tipAlert({
                                    type: "success",
                                    msg: React.language("link.copySuccess")
                                })
                            })

                        }}>{React.language('copy')}</div> : ''
                    }
                    {
                        this.options.hasOpen ? <a className="btn open" rel="noreferrer" target="_blank" href={url} title={React.language('openLink')}>{React.language('open')}</a> : ''
                    }
                    {
                        this.options.hasQrcode ? <div className="btn qr-code" onClick={e => {

                            window.$(".qrcode-dropdown").remove();
                            var t = window.$('<div className="qrcode-dropdown"/>');
                            window.$("<div id ='qrcode' style='border:solid 10px #fff;' />").appendTo(t);
                            window.$("<div/>").text('微信"扫一扫"，分享给好友').appendTo(t);

                            window.FX.Msg.bubble({
                                anchor: window.$(e.currentTarget),
                                text4Ok: null,
                                text4Cancel: null,
                                contentHTML: t,
                                minWidth: 150,
                                dockPosition: "right"
                            })
                            //替换 qrcode.min库
                            var qrcode = new window.QRCode('qrcode', {
                                text: url,
                                width: 160,
                                height: 160,
                            });

                        }}><a title={React.language('qrCode')}><i className="icon-qrcode"></i></a></div> : ''
                    }
                </div>
            </div>
        );
    }
}

export default BsyShareUrlPane;